const FORGET_PASSWORD = {
  CARD_TITLE: "Password Recovery",
  CARD_SUB_TITLE:
    "Enter your email address, Raychat will email you recovery instructions.",
  EMAIL_PH: "Email",
  SEND: "Send",
  BACK_TO_LOGIN: "Back to login",
};

export default FORGET_PASSWORD;
